import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";
import { Unit } from "src/app/backoffice/inv/models/unit.model";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";

@Component({
  selector: "ngx-unit-form",
  templateUrl: "./MeasurementUnit-form.component.html",
  styleUrls: ["./MeasurementUnit-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasurementUnitFormComponent extends BaseFormComponent<Unit> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }
  deactivateSave: boolean = false;
  async ngOnInit() {
    this.apiName = "MeasurementUnit";
    this.label = this.translate("ClientApp.BackOffice.INV.Unit.Unit");
    super.ngOnInit();
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <Unit>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setdefault();
        this.setFormGroup(this.model);
      });
  }
  addControl() {
    this.cd.markForCheck();
  }
  async FillData() {
    const currentInformation = this.accountService.authService.currentInformation();
    if (currentInformation.BranchingLightEnabled || currentInformation.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Unit")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (hbc: CheckBrachAccessModel) => {
            if (hbc.TransferKindCode != 3) {
              if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.MeasurementUnit.HasBranchCommunication"),
                  this.translate("ClientApp.FrontOffice.MeasurementUnit.Attention")
                );
                this.deactivateSave = true;
                return;
              } else {
                if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                  this.sts.showDialog(
                    this.translate("ClientApp.FrontOffice.MeasurementUnit.HasCallCenterCommunication"),
                    this.translate("ClientApp.FrontOffice.MeasurementUnit.Attention")
                  );
                  this.deactivateSave = true;
                  return;
                }
              }
            }
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
}
